export default "__VITE_ASSET__BLR$rvax__"